import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = "user";

const userInfo = JSON.parse(localStorage.getItem("userInfo"));
if (userInfo && userInfo.user.role) {
  initialRole = userInfo.user.role.toLowerCase();
}

export default new AclCreate({
  initial: initialRole,
  notfound: {
    path: "/pages/not-authorized",
    forwardQueryParams: true,
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    isAdmin: new AclRule("admin").generate(),
    isUser: new AclRule("user").generate(),
    isBoth: new AclRule("admin").or("user").generate(),
  },
});
